module.exports = {"130502001":"南长街街道","130502002":"北大街街道","130502003":"西大街街道","130502004":"西门里街道","130502005":"泉东街道","130502006":"豫让桥街道","130502100":"东郭村镇","130502101":"祝村镇","130502103":"晏家屯镇","130502200":"大梁庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130502.json
// module id = 217
// module chunks = 0